import { useStore } from "../../store";
import { useQueryClient } from "@tanstack/react-query";
import { useApi } from "@lib/helpers/useApi";
import type { Customer } from "@lib/api-services/services/profile-service/types";
import { invalidateProfileQueries } from "@store/helpers/profile/invalidateProfileQueries";

export const useAddAddressToCustomer = () => {
    const setData = useStore((state) => state.setMyAddresses);
    const queryClient = useQueryClient();

    const mutation = useApi.useMutate<any, Customer>(`/api/addresses/add-address`, {
        method: "POST",
        onSuccess: (data) => {
            // Update zustand store
            setData(data);
            // Invalidate and refetch addresses, so we have the new address in the list
            invalidateProfileQueries(queryClient);
        },
    });
    return { addAddressMutation: mutation };
};

export const useUpdateAddressToCustomer = () => {
    const queryClient = useQueryClient();
    const setData = useStore((state) => state.setMyAddresses);

    const mutation = useApi.useMutate<any, Customer>(`/api/addresses/update-address`, {
        method: "PUT",
        onSuccess: (data) => {
            // We need to match types from SFAPI and GraphQL
            setData(data);
            // Invalidate and refetch addresses, so we have the new address in the list
            invalidateProfileQueries(queryClient);
        },
    });
    return { updateAddressMutation: mutation };
};

export const useRemoveAddressToCustomer = () => {
    const setData = useStore((state) => state.setMyAddresses);
    const queryClient = useQueryClient();
    // Ask BE why Swagger is not generating request/response types for delete-address
    const mutation = useApi.useMutate<any, Customer>(`/api/addresses/delete-address`, {
        method: "DELETE",
        onSuccess: (data) => {
            // Update zustand store
            setData(data);
            // Invalidate and refetch addresses, so we have the new address in the list
            invalidateProfileQueries(queryClient);
        },
    });
    return { deleteAddressMutation: mutation };
};
